import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TrackeritemQueueService } from '../../../services/trackeritem.queue.service'
import { TrackerService } from '../../../services/tracker.service';
import { GfTranslateService } from '../../../../../core/services/core.translate.service';
import { StateService } from '@uirouter/angular';

import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-browse-list',
  template: require('./trackeritem.browse.list.component.html')
})
export class TrackeritemBrowseListComponent {
  @Input() tracker: any;
  @Input() trackeritems: any;
  @Input() acls: any;
  @Input() options: any = {};
  
  @Output() onChecked: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUpdate: EventEmitter<any> = new EventEmitter<any>();

  priorities: any;
  selectedItems: any = [];
  allChecked: boolean = false;

  constructor(
    private trackerService: TrackerService,
    private trackeritemQueueService: TrackeritemQueueService,
    private translateService: GfTranslateService,
    private stateService: StateService, 
  ) {}

  ngOnInit() {
    this.priorities = this.trackerService.fields.builtIn.priority.getList();
  }

  setAssigneeOnItem(event: any) {
    this.onUpdate.emit({
      item: event.item,
      fieldName: 'assignee',
      fieldValue: event.assignee
    });
  }

  setFieldValueAndSave(item, fieldName, fieldValue) {
    this.onUpdate.emit({
        item: item,
        fieldName: fieldName,
        fieldValue: fieldValue
    });
  }

  // BEGIN Queue methods
  toggleQueue(trackeritem) {
    this.trackeritemQueueService.toggleQueue(trackeritem, this.acls.canAssign);
  }

  canUpdateQueue(trackeritem) {
    return this.trackeritemQueueService.canUpdateQueue(trackeritem, this.acls.canAssign);
  }

  inQueue(trackeritem) {
    return this.trackeritemQueueService.inQueue(trackeritem);
  }

  queueButtonTitle(item: any): string {
    if (this.trackeritemQueueService.inQueue(item)) {
      return this.translateService.translate('This Tracker Item is in your To-Do. Click to remove');
    } else {
      return this.translateService.translate('This Tracker Item is not in your To-Do. Click to add');
    }
  }
  // END Queue methods

  openTrackeritemEditModal(item: any) {
    this.onEdit.emit(item);
  }

  getFieldElementsByWorkflow(alias: string, elementName: string) {
    return this.trackerService.workflow.getFieldElementsByWorkflow(this.tracker, alias, elementName);
  }

  toggleAllItems() {
    this.allChecked = !this.allChecked;
    if (!this.allChecked) {
      this.selectedItems = [];
    } else {
      if (Array.isArray(this.trackeritems)) {
        this.selectedItems = _.map(this.trackeritems, (item) => {
          return item.id;
        })
      }
    }

    this.onChecked.emit({items: this.selectedItems});
  }

  toggleSelectItem(item) {
    if (this.isSelected(item.id)) {
      _.pull(this.selectedItems, item.id);
    } else {
      this.selectedItems.push(item.id);
    }
    
    this.onChecked.emit({items: this.selectedItems});
  }

  isSelected(tid: any): boolean {
    return _.includes(this.selectedItems, tid);
  }

  // #65237 Iteration 3: closed/total from rel.child_status (bulk-loaded via rel=child_status),
  // total from subitemsCount (trigger-maintained, always present) -- for the row floodbar.
  getChildStatusData(item: any): any {
    const closed = _.get(item, 'rel.child_status.closed', 0);
    const total = _.get(item, 'subitemsCount', 0);
    return {
      percentComplete: total ? (closed / total) * 100 : 0,
      amountComplete: closed,
      amountTotal: total
    };
  }

  trackByFn(index: number, item: any): any {
    return item.id;
  }
}
